














import { Component, Vue, Prop } from 'vue-property-decorator';

import QuestionTitle from './question-title.vue';
import { InputItem } from '@/components/form';
import { Question } from '@/domains/template';

@Component({
  name: 'MultiInput',
  components: {
    'my-input': InputItem,
    'question-title': QuestionTitle,
  },
})
export default class MultiInput extends Vue {
  @Prop()
  private value: Question;

  @Prop({ default: false })
  private save: boolean;

  get question(): Question {
    return this.value;
  }

  set question(value: Question) {
    this.$emit('input', value);
  }
}
